import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	.search-components {
		position: relative;
		max-width: 440px;
		margin: 0 auto;

		.reset {
			position: absolute;
			top: 6px;
			right: 10px;
			color: inherit;
			cursor: pointer;
			color: gray;
		}

		input {
			padding-right: 20px;
			position: relative;
			background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.34938 1.60176C7.21356 -0.533921 3.73735 -0.533921 1.60152 1.60176C-0.53384 3.73791 -0.53384 7.21343 1.60152 9.34958C3.50353 11.251 6.46581 11.4547 8.60025 9.96996C8.64516 10.1825 8.74795 10.3852 8.91324 10.5505L12.0237 13.6608C12.477 14.1131 13.2094 14.1131 13.6604 13.6608C14.1132 13.208 14.1132 12.4756 13.6604 12.0242L10.5499 8.913C10.3856 8.7491 10.1823 8.64586 9.96981 8.60095C11.4556 6.46619 11.2519 3.50457 9.34938 1.60176ZM8.36736 8.36761C6.77278 9.96209 4.17766 9.96209 2.58355 8.36761C0.989897 6.77314 0.989897 4.17866 2.58355 2.58419C4.17766 0.990178 6.77278 0.990178 8.36736 2.58419C9.96194 4.17866 9.96194 6.77314 8.36736 8.36761Z' fill='%23B4B4B4'/%3E%3C/svg%3E%0A");
			background-position: 13px 45%;
			background-repeat: no-repeat;
			width: 100%;
		}
	}

	.posts {
		max-width: 1420px;
		margin: 50px auto 0;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin: 100px auto 0;
		}

		a {
			background-color: ${CSSVars.gray100};
			position: relative;
		}

		.post {
			border-radius: 10px;
			overflow: hidden;

			&:hover {
				.details {
					h3 {
						color: ${CSSVars.primary500};
					}
					.read-more {
						color: ${CSSVars.primary300};
					}
				}
			}

			&.first-post {
				margin-bottom: 100px;
				display: flex;
				align-items: center;

				flex-direction: column;
				gap: 10px;

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					flex-direction: row;
					gap: 50px;
				}

				.details {
					background-color: transparent;

					h3 {
						font-size: ${CSSVars.fontSize2XL};

						@media screen and (min-width: ${CSSVars.breakpointXL}) {
							font-size: ${CSSVars.fontSize4XL};
						}
					}

					.author {
						font-size: ${CSSVars.fontSizeXS};

						@media screen and (min-width: ${CSSVars.breakpointLG}) {
							font-size: ${CSSVars.fontSizeSM};
						}
					}

					.desc {
						font-size: ${CSSVars.fontSizeMD};
						-webkit-line-clamp: 5; /* number of lines to show */
						line-clamp: 5;
						margin-bottom: 20px;

						@media screen and (min-width: ${CSSVars.breakpointLG}) {
							font-size: ${CSSVars.fontSizeLG};
						}
					}

					.read-more {
						font-size: ${CSSVars.fontSizeMD};
						position: static;

						@media screen and (min-width: ${CSSVars.breakpointXL}) {
							font-size: ${CSSVars.fontSizeLG};
						}
					}
				}

				img {
					border-radius: 10px;
					max-width: 600px;
					width: 100%;
					height: 100%;
				}
			}

			img {
				object-fit: cover;
				height: 200px;
				width: 100%;
				border-radius: 10px 10px 0 0;
			}

			.details {
				padding: 20px 20px 40px;
				color: ${CSSVars.gray900};

				h3 {
					transition: 0.2s;
					font-size: ${CSSVars.fontSizeLG};
					font-weight: 600;
				}

				.author {
					font-size: ${CSSVars.fontSizeXS};
					color: ${CSSVars.gray400};
					font-weight: 300;
					margin: 5px 0 10px;
				}

				.desc {
					font-size: ${CSSVars.fontSizeSM};
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4; /* number of lines to show */
					line-clamp: 4;
					-webkit-box-orient: vertical;
					margin-bottom: 10px;
				}

				.read-more {
					color: ${CSSVars.primary500};
					font-size: ${CSSVars.fontSizeSM};
					font-weight: 600;
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 10px;
					margin-left: auto;
					transition: 0.2s;
					width: fit-content;
					border: none;
					background-color: transparent;
					cursor: pointer;

					position: absolute;
					bottom: 20px;
					right: 20px;

					&:hover {
						color: ${CSSVars.primary300};
					}
				}
			}
		}

		.posts-container {
			display: grid;
			grid-gap: 50px;
			grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
		}

		.no-items {
			display: flex;
			align-items: center;
			flex-direction: column;
			gap: 20px;
			margin: 0 auto 100px;
			text-align: center;

			button {
				font-size: 14px;
			}
		}
	}
`;
